<div class="mdc-layout-grid__inner">
	<div class="mdc-layout-grid__cell--span-12">
		<div class="ad">
			<div class="cover">
				<img *ngIf="locale.lang == 'en'" [src]="enVipImage" />

				<img *ngIf="locale.lang == 'ku'" [src]="kuVipImage" />

				<img *ngIf="locale.lang == 'ar'" [src]="arVipImage" />
			</div>
		</div>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<h4 class="pink" id="n181">{{ locale.translations['vip']['n181'] }}</h4>

		<ul class="list li-padding">
			<li id="n449">
				<mat-icon color="accent">verified_user</mat-icon>
				&nbsp;

				<span>{{ locale.translations['vip']['n449'] }}</span>
			</li>

			<li id="n456">
				<mat-icon color="accent">verified_user</mat-icon>
				&nbsp;

				<span>{{ locale.translations['vip']['n456'] }}</span>
			</li>

			<li id="n457">
				<mat-icon color="accent">verified_user</mat-icon>
				&nbsp;

				<span>{{ locale.translations['vip']['n457'] }}</span>
			</li>

			<li id="n458">
				<mat-icon color="accent">verified_user</mat-icon>
				&nbsp;

				<span>{{ locale.translations['vip']['n458'] }}</span>
			</li>

			<li id="n459">
				<mat-icon color="accent">verified_user</mat-icon>
				&nbsp;

				<span>{{ locale.translations['vip']['n459'] }}</span>
			</li>

			<li id="n460">
				<mat-icon color="accent">verified_user</mat-icon>
				&nbsp;

				<span>{{ locale.translations['vip']['n460'] }}</span>
			</li>
		</ul>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<mat-divider></mat-divider>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<h4 class="pink" id="n183">{{ locale.translations['vip']['n183'] }}</h4>

		<div class="pay-btn-cont">
			<a class="w-100" [routerLink]="[login ? '/user/' + userId + '/ads' : '/login']" mat-flat-button color="accent">
				{{ locale.translations['pricing']['n227'] }}
			</a>

			<div class="text-center font-weight-semi-bold" style="padding: 1.125em 0">
				{{ locale.translations['ads']['ad']['n391'] }}
			</div>
		</div>

		<div class="list-padding phone_cont">
			<span class="altPay" id="n184">{{ locale.translations['vip']['n1472'] }}</span>

			<span class="altPay" id="n184">{{ locale.translations['vip']['n184'] }}</span>

			<ul class="list">
				<li id="n103">
					<a href="tel:07512347071">
						<mat-icon class="mat-icon-rtl-mirror" color="accent">call</mat-icon>
						&nbsp;

						<span>{{ locale.translations['premium']['n103'] }}</span>
					</a>
				</li>

				<li id="n104">
					<a href="tel:07706921858">
						<mat-icon class="mat-icon-rtl-mirror" color="accent">call</mat-icon>
						&nbsp;

						<span>{{ locale.translations['premium']['n104'] }}</span>
					</a>
				</li>
			</ul>
		</div>
	</div>
</div>
